module.exports = __webpack_public_path__ + "img/wx_bar.09985b5b.svg";